import api from '../api';

export default (apiOptions, actions) => {
  const { getResource } = actions;
  return {
    id: 'sort',
    shouldBeAvailable: () => true,
    handler: async ({ sortBy, sortDirection }) => {
      const resource = getResource();
      return api.getChildrenForId(apiOptions, { id: resource.id, systemFolderType: resource.systemFolderType, sortBy, sortDirection });
    },
  };
};
